function formatMoney(cents) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(cents / 100);
}

document.addEventListener('DOMContentLoaded', () => {

  // =========================
  // GUARD: RUN ONLY ON BUNDLE PDP
  // =========================
  const bundleRoot = document.querySelector('.subscription-bundle');
  if (!bundleRoot) return;

  function clearActiveIfOtherCardChanged(changedCard) {
    const activeCard = document.querySelector('.subscription-bundle .bundle-card.active');
    if (!activeCard || !changedCard) return;
    if (activeCard !== changedCard) {
      activeCard.classList.remove('active');
    }
  }

  function getPlanSelect(card) {
    return card?.querySelector('.bundle-selling-plan, select.bundle-plan');
  }

  function getSellingPlanId(card) {
    // Always prefer the live <select> when it still has a numeric plan.
    // Fall back to data-selling-plan-id if Appstle cleared the select.
    const select = getPlanSelect(card);
    if (select) {
      let value = select.value;
      if (!value && select.options.length) {
        value = select.options[0].value;
        select.value = value;
      }
      const fromSelect = parseInt(value, 10);
      if (Number.isFinite(fromSelect) && fromSelect > 0) {
        card.dataset.sellingPlanId = String(fromSelect);
        return fromSelect;
      }
    }

    const fromData = parseInt(card?.dataset?.sellingPlanId, 10);
    return Number.isFinite(fromData) && fromData > 0 ? fromData : null;
  }

  function persistSellingPlanId(card) {
    if (!card || !card.classList.contains('bundle-card--subscription')) return;
    const planId = getSellingPlanId(card);
    if (planId) card.dataset.sellingPlanId = String(planId);
  }

  /**
   * Appstle patches window.fetch / XHR for /cart/add.js and overwrites
   * items[].selling_plan with `.appstle_sub_widget input[name=selling_plan]:checked`.
   * If that radio is one-time ("" ) or a non-id label like "Subscribe and save",
   * Shopify adds a one-time line instead of the subscription.
   *
   * Sync Appstle's checked value to our plan id for the duration of the request.
   */
  function withAppstlePlanSync(items, run) {
    const subscriptionItem = items.find((item) => item.selling_plan);
    const hasOnetimeItem = items.some((item) => !item.selling_plan);
    const planId = subscriptionItem ? String(subscriptionItem.selling_plan) : '';

    const radios = Array.from(
      document.querySelectorAll('.appstle_sub_widget input[name="selling_plan"]')
    );
    const previous = radios.map((radio) => ({
      radio,
      checked: radio.checked,
      disabled: radio.disabled
    }));

    let tempWidget = null;
    let tempRadio = null;

    const neutralizeAppstle = () => {
      // No checked plan → Appstle skips item rewrite and leaves our payload alone.
      radios.forEach((radio) => {
        radio.checked = false;
        radio.disabled = true;
      });
    };

    const ensureCheckedPlan = (value) => {
      const match = radios.find((radio) => String(radio.value) === String(value));
      if (match) {
        radios.forEach((radio) => {
          radio.checked = radio === match;
        });
        return;
      }

      // No matching Appstle radio — inject one so the interceptor reads our plan.
      tempWidget = document.querySelector('.appstle_sub_widget');
      if (!tempWidget) {
        tempWidget = document.createElement('div');
        tempWidget.className = 'appstle_sub_widget';
        tempWidget.hidden = true;
        tempWidget.setAttribute('data-bundle-appstle-sync', 'true');
        document.body.appendChild(tempWidget);
      }

      tempRadio = document.createElement('input');
      tempRadio.type = 'radio';
      tempRadio.name = 'selling_plan';
      tempRadio.value = value;
      tempRadio.checked = true;
      tempRadio.hidden = true;
      tempRadio.setAttribute('data-bundle-appstle-sync', 'true');
      tempWidget.appendChild(tempRadio);

      radios.forEach((radio) => {
        radio.checked = false;
      });
    };

    if (planId && hasOnetimeItem) {
      // Both lines for the same variant: Appstle's interceptor would collapse
      // them into one. Disable it so both one-time + subscription are kept.
      neutralizeAppstle();
    } else if (planId) {
      ensureCheckedPlan(planId);
    } else if (radios.length) {
      // Pure one-time add: force Appstle one-time radio so it doesn't attach a plan.
      const oneTime = radios.find((radio) => radio.value === '') || radios[0];
      radios.forEach((radio) => {
        radio.checked = radio === oneTime;
      });
      if (oneTime && oneTime.value !== '') {
        neutralizeAppstle();
      }
    }

    const restore = () => {
      previous.forEach(({ radio, checked, disabled }) => {
        radio.checked = checked;
        radio.disabled = disabled;
      });
      if (tempRadio) tempRadio.remove();
      if (tempWidget && tempWidget.getAttribute('data-bundle-appstle-sync') === 'true') {
        tempWidget.remove();
      }
    };

    return Promise.resolve()
      .then(run)
      .finally(restore);
  }

  // =========================
  // 1. QUANTITY CONTROLS
  // =========================
  document.addEventListener('click', (e) => {

    const minus = e.target.closest('.bundle-qty__adjust--minus');
    const plus = e.target.closest('.bundle-qty__adjust--plus');

    if (!minus && !plus) return;

    const wrapper = e.target.closest('.bundle-qty__wrapper');
    const input = wrapper.querySelector('.bundle-qty__num');

    let value = parseInt(input.value) || 0;

    if (plus) value++;
    if (minus) value = Math.max(0, value - 1);

    input.value = value;

    const card = e.target.closest('.bundle-card');
    clearActiveIfOtherCardChanged(card);
    updateAll(card);

  });

  // =========================
  // 2. CALCULATE UNIT PRICE
  // =========================
  function getUnitPrice(card) {

    const basePrice = parseInt(card.dataset.basePrice) || 0;
    const select = getPlanSelect(card);

    let unitPrice = basePrice;

    if (select) {
      const option = select.selectedOptions[0];
      if (!option) return unitPrice;

      // Prefer allocation price from Liquid (standalone + multi-plan)
      if (option.dataset.price != null && option.dataset.price !== '') {
        return parseInt(option.dataset.price, 10) || 0;
      }

      const type = option.dataset.type;
      const value = parseFloat(option.dataset.value) || 0;

      if (type === 'percentage') {
        unitPrice = Math.round(basePrice * (1 - value / 100));
      }

      if (type === 'fixed_amount') {
        unitPrice = basePrice - value;
      }
    }

    return unitPrice;
  }

  function syncSubscriptionCardFromPlan(card) {
    if (!card || !card.classList.contains('bundle-card--subscription')) return;

    const select = getPlanSelect(card);
    const option = select?.selectedOptions?.[0];
    if (!option) return;

    const planId = parseInt(option.value, 10);
    if (Number.isFinite(planId) && planId > 0) {
      card.dataset.sellingPlanId = String(planId);
    }

    if (option.dataset.price != null && option.dataset.price !== '') {
      card.dataset.basePrice = String(parseInt(option.dataset.price, 10) || 0);
    }

    const badge = card.querySelector('[data-subscription-badge]');
    if (badge && option.dataset.savePercent) {
      badge.textContent = `Subscribe & Save ${option.dataset.savePercent}%`;
    }
  }

  // =========================
  // 3. UPDATE ROW
  // =========================
  function updateRow(card) {

    const qtyInput = card.querySelector('.bundle-qty__num');
    const quantity = parseInt(qtyInput?.value) || 0;

    const unitPrice = getUnitPrice(card);
    const rowTotal = unitPrice * quantity;

    // store total
    card.dataset.productPrice = rowTotal;

    const priceEl = card.querySelector('.bundle-price');
    if (!priceEl) return;

    if (quantity > 0) {
      priceEl.textContent = formatMoney(rowTotal);
    } else {
      priceEl.textContent = formatMoney(unitPrice);
    }

  }

  // =========================
  // 4. UPDATE TOTAL
  //    Writes to a dedicated bundle-total element so the main
  //    .product__price stays untouched. The sticky add-to-cart bar
  //    mirrors this element when present (see sticky-add-to-cart.js).
  //
  //    The total includes:
  //      - bundle cards (qty * unit price, already stored on
  //        card.dataset.productPrice by updateRow())
  //      - frequently-bought-together slides (qty * data-unit-price)
  // =========================
  function updateTotal() {

    let total = 0;

    document.querySelectorAll('.bundle-card').forEach(card => {
      total += parseInt(card.dataset.productPrice) || 0;
    });

    document.querySelectorAll('[data-fbt-slider] [data-fbt-slide]').forEach(slide => {
      const qtyInput = slide.querySelector('[data-fbt-qty]');
      const qty = qtyInput ? parseInt(qtyInput.value, 10) || 0 : 0;
      if (qty <= 0) return;
      const unit = parseInt(slide.dataset.unitPrice, 10) || 0;
      total += unit * qty;
    });

    const totalWrap = document.querySelector('[data-bundle-total]');
    const totalPrice = document.querySelector('[data-bundle-total-price]');
    if (!totalWrap || !totalPrice) return;

    if (total === 0) {
      totalWrap.hidden = true;
      return;
    }

    totalPrice.textContent = formatMoney(total);
    totalWrap.hidden = false;
  }

  // =========================
  // 5. MASTER UPDATE
  // =========================
  function updateAll(card) {
    updateRow(card);
    updateTotal();
    updateBundleButtonState();
  }

  // =========================
  // 6. LISTENERS
  // =========================

  // manual qty input
  document.addEventListener('input', (e) => {
    if (!e.target.classList.contains('bundle-qty__num')) return;

    const card = e.target.closest('.bundle-card');
    clearActiveIfOtherCardChanged(card);
    updateAll(card);
  });

  // subscription change
  document.addEventListener('change', (e) => {
    const select = e.target.closest('.bundle-selling-plan, select.bundle-plan');
    if (!select) return;

    const card = select.closest('.bundle-card');
    syncSubscriptionCardFromPlan(card);
    updateAll(card);
  });

  // =========================
  // 7. INITIAL LOAD
  // =========================
  document.querySelectorAll('.bundle-card').forEach(card => {
    card.dataset.productPrice = 0;
    persistSellingPlanId(card);
    updateRow(card);
  });

  // Hide Appstle's duplicate purchase-option widget on bundle PDPs —
  // our UI owns one-time vs subscribe, and Appstle's radios fight ATC.
  document.documentElement.classList.add('has-subscription-bundle');
  document.querySelectorAll('.appstle_sub_widget').forEach((widget) => {
    widget.setAttribute('data-bundle-hidden', 'true');
    widget.hidden = true;
  });

  updateTotal();

  function getBundleItems() {

  const items = [];

  const cards = Array.from(document.querySelectorAll('.bundle-card')).reverse();

  cards.forEach(card => {

    const qty = parseInt(card.querySelector('.bundle-qty__num')?.value) || 0;
    if (qty <= 0) return;

    const id = parseInt(card.dataset.variantId, 10);
    if (!Number.isFinite(id)) return;

    const type = card.dataset.type;

    // ONE-TIME
    if (type === 'starter' || type === 'refill_onetime') {
      items.push({ id, quantity: qty });
    }

    // SUBSCRIPTION
    if (type === 'refill_subscription') {
      const plan = getSellingPlanId(card);

      if (plan) {
        items.push({
          id,
          quantity: qty,
          selling_plan: plan
        });
      }
    }

  });

  // FBT slider: append every slide with qty > 0 to the same /cart/add.js call
  document.querySelectorAll('[data-fbt-slider] [data-fbt-slide]').forEach(slide => {
    const qtyInput = slide.querySelector('[data-fbt-qty]');
    const qty = qtyInput ? parseInt(qtyInput.value, 10) || 0 : 0;
    if (qty <= 0) return;

    const id = slide.dataset.variantId;
    if (!id) return;

    items.push({ id, quantity: qty });
  });

  return items;
}

  // =========================
  // FBT slider — qty stepper + slide navigation
  // =========================
  initFbtSlider();

  function initFbtSlider() {
    const slider = document.querySelector('[data-fbt-slider]');
    if (!slider) return;

    const track = slider.querySelector('[data-fbt-track]');
    const slides = Array.from(slider.querySelectorAll('[data-fbt-slide]'));
    const prevBtn = slider.querySelector('[data-fbt-prev]');
    const nextBtn = slider.querySelector('[data-fbt-next]');
    const dots = Array.from(slider.querySelectorAll('[data-fbt-dot]'));

    if (!track || slides.length === 0) return;

    // ----- Qty stepper -----
    slider.addEventListener('click', (e) => {
      const minus = e.target.closest('[data-fbt-qty-minus]');
      const plus = e.target.closest('[data-fbt-qty-plus]');
      if (!minus && !plus) return;

      const slide = e.target.closest('[data-fbt-slide]');
      if (!slide) return;

      const input = slide.querySelector('[data-fbt-qty]');
      if (!input) return;

      let value = parseInt(input.value, 10) || 0;
      if (plus) value++;
      if (minus) value = Math.max(0, value - 1);

      input.value = value;
      slide.classList.toggle('is-selected', value > 0);

      // Bundle ATC enables once anything (bundle or FBT) is selected,
      // and the bundle total / sticky bar reflect the new FBT line.
      updateTotal();
      updateBundleButtonState();
    });

    slider.addEventListener('input', (e) => {
      if (!e.target.matches('[data-fbt-qty]')) return;
      const slide = e.target.closest('[data-fbt-slide]');
      let value = parseInt(e.target.value, 10);
      if (isNaN(value) || value < 0) value = 0;
      e.target.value = value;
      if (slide) slide.classList.toggle('is-selected', value > 0);
      updateTotal();
      updateBundleButtonState();
    });

    // ----- Slide navigation -----
    function getCurrentIndex() {
      const trackRect = track.getBoundingClientRect();
      const trackCenter = trackRect.left + trackRect.width / 2;
      let nearest = 0;
      let nearestDist = Infinity;
      slides.forEach((slide, i) => {
        const r = slide.getBoundingClientRect();
        const d = Math.abs(r.left + r.width / 2 - trackCenter);
        if (d < nearestDist) { nearestDist = d; nearest = i; }
      });
      return nearest;
    }

    function goTo(index) {
      const clamped = Math.max(0, Math.min(slides.length - 1, index));
      slides[clamped].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    }

    function syncControls() {
      const i = getCurrentIndex();
      dots.forEach((dot, di) => {
        const active = di === i;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      if (prevBtn) prevBtn.disabled = i === 0;
      if (nextBtn) nextBtn.disabled = i === slides.length - 1;
    }

    if (prevBtn) prevBtn.addEventListener('click', () => goTo(getCurrentIndex() - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => goTo(getCurrentIndex() + 1));

    dots.forEach(dot => {
      dot.addEventListener('click', () => {
        const idx = parseInt(dot.dataset.index, 10) || 0;
        goTo(idx);
      });
    });

    let scrollTimeout;
    track.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(syncControls, 80);
    });

    syncControls();
  }

  // =========================
  // 8. ADD TO CART OVERRIDE
  // =========================
  async function postCartItems(items) {
    return withAppstlePlanSync(items, () =>
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      })
    );
  }

  /**
   * Appstle's /cart/add.js interceptor collapses same-variant lines when a
   * selling_plan radio is checked. Post subscription lines and one-time
   * lines in separate requests so both survive.
   */
  async function addBundleItemsToCart(items) {
    const subscriptionItems = items.filter((item) => item.selling_plan);
    const otherItems = items.filter((item) => !item.selling_plan);
    const batches = [];

    if (subscriptionItems.length) batches.push(subscriptionItems);
    if (otherItems.length) batches.push(otherItems);

    for (const batch of batches) {
      const response = await postCartItems(batch);
      if (!response.ok) {
        throw new Error('Add to cart failed');
      }
    }
  }

  function initBundleAddToCart() {

  const button = document.querySelector('.bundle-add-to-cart');
  if (!button) return;

  button.addEventListener('click', async () => {

    const items = getBundleItems();

    if (!items.length) {
      alert('Please select at least one item.');
      return;
    }

    // ✅ LOADING START
    button.classList.add('btn--loading');
    button.disabled = true;

    try {

      await addBundleItemsToCart(items);

      // Open the cart drawer instead of redirecting to /cart.
      // theme.CartDrawer listens for `ajaxProduct:added` to rebuild
      // the cart contents and then open the drawer.
      document.dispatchEvent(new CustomEvent('ajaxProduct:added'));

      // Fallback for stores where the cart drawer isn't wired up:
      // dispatch the explicit open event too. CartDrawer.init() listens
      // for this; if no drawer exists, it's a no-op.
      document.dispatchEvent(new CustomEvent('cart:open'));

      // Reset bundle quantities so the user can build another bundle
      // without leftover state from this purchase.
      document.querySelectorAll('.subscription-bundle .bundle-qty__num').forEach(input => {
        input.value = 0;
      });
      document.querySelectorAll('[data-fbt-slider] [data-fbt-qty]').forEach(input => {
        input.value = 0;
        const slide = input.closest('[data-fbt-slide]');
        if (slide) slide.classList.remove('is-selected');
      });
      document.querySelectorAll('.subscription-bundle .bundle-card').forEach(card => {
        card.dataset.productPrice = 0;
        updateRow(card);
      });
      updateTotal();

      button.classList.remove('btn--loading');
      updateBundleButtonState();

    } catch (err) {
      console.error(err);
      alert('Error adding to cart');

      // ✅ RESET ONLY ON ERROR
      button.classList.remove('btn--loading');
      updateBundleButtonState();
    }

  });

}

function hasSelection() {
  const hasBundleSelection = Array.from(document.querySelectorAll('.bundle-card'))
    .some(card => (parseInt(card.querySelector('.bundle-qty__num')?.value) || 0) > 0);

  if (hasBundleSelection) return true;

  // Also enable the ATC if only an FBT item is selected
  return Array.from(document.querySelectorAll('[data-fbt-slider] [data-fbt-qty]'))
    .some(input => (parseInt(input.value, 10) || 0) > 0);
}

function updateBundleButtonState() {

  const button = document.querySelector('.bundle-add-to-cart');
  if (!button) return;

  if (button.classList.contains('btn--loading')) return;

  const enabled = hasSelection();

  button.disabled = !enabled;
  button.classList.toggle('is-disabled', !enabled);

}

  // =========================
  // 9. RELOCATE ATC TO TOP
  //
  // Move `.bundle-add-to-cart` up next to the first
  // `.product-block.app--block` (typically the Judge.me reviews
  // widget) if present, otherwise next to `.product-block--price`,
  // so customers can add to cart without scrolling past the bundle.
  // The button keeps its DOM identity (and thus all already-bound
  // listeners / observers from the bundle + sticky-bar scripts).
  //
  // The button is wrapped in a `.bundle-atc-row__cta` cell so layout
  // tweaks (right-aligning on small screens, etc.) live on the
  // wrapper instead of the button itself.
  // =========================
  function relocateBundleAddToCart() {
    const button = document.querySelector('.bundle-add-to-cart');
    if (!button) return;

    const meta = document.querySelector('.product-single__meta');
    if (!meta) return;

    const target =
      meta.querySelector('.product-block.app--block') ||
      meta.querySelector('.product-block--price');

    if (!target || !target.parentElement) return;

    let row = target.parentElement;
    if (!row.classList.contains('bundle-atc-row')) {
      row = document.createElement('div');
      row.className = 'bundle-atc-row';
      target.parentElement.insertBefore(row, target);
      row.appendChild(target);
    }

    let cta = row.querySelector(':scope > .bundle-atc-row__cta');
    if (!cta) {
      cta = document.createElement('div');
      cta.className = 'bundle-atc-row__cta';
      row.appendChild(cta);
    }

    if (button.parentElement !== cta) {
      cta.appendChild(button);
    }
  }

  relocateBundleAddToCart();

  initBundleAddToCart();
  updateBundleButtonState();

});